import { MealFactory } from './mealFactory';

import type { MealEntity, MealPropsPvt, MealPropsPub } from './mealEntity';
import type { MealIRepository } from './mealIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { MealJsonPvt, MealJsonPub } from '@/types/domain/meal/entities/mealEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class MealRepository extends AppsyncRepository<
  MealEntity,
  MealPropsPvt,
  MealJsonPvt,
  MealPropsPub,
  MealJsonPub
> implements MealIRepository {
  private factory = new MealFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoAppMealMealEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
